<template>
    <div class="upload-image-for-pro" :class="['type-' + type]">
        <div class="ui-modal--container">
            <slot></slot>
            <div class="title-box">
                <div class="title">{{ title }}</div>
                <svg-icon name="close" @click="$emit('closeModal')"/>
            </div>

            <Loading class="static" v-if="is_loading" />
            <div v-else>
                <div class="upload">      
                    <label for="file-input" class="img-wrap">
                        <div class="img-wrap-placeholder">
                            <div class="image-placeholder">
                                <span>Click here to select a image</span>
                                <Button :border_r="6" size="40" color="dark-blue" :flex="true">
                                    <svg-icon name="plus"/>
                                    SELECT IMAGE
                                </Button>
                            </div>
                            <input id="file-input" class="avatar-input" type="file" ref="file" @change="loadImage($event)" accept="image/png, image/jpeg" hidden>
                        </div>
                    </label>

                    <cropper :class="[img_data.src && 'vue-advanced-cropper-class']" ref="cropper"  :default-size="defaultSize"
                        @change="onChange" :canvas="{
                            minHeight: 0,
                            minWidth: 0,
                            maxWidth: 670,
                            maxHeight: 370,
                    }" :src="img_data.src" />
                </div>

                <div class="tools" v-if="img_data.src"> 
                    <div class="t-desc ">zoom</div>
                    <i :class="[ scale_current===0 &&'disabeld']" @click="handleScaleValue(1)"><svg-icon name="less" /></i>
                    <VueSlider v-model="scale_current" :zoom="1.1" :adsorb="true" :min="0" :max="5" @change="changeScale" :key="scale_key"/>
                    <i :class="[ scale_current===10 &&'disabeld']" @click="handleScaleValue(0)"><svg-icon name="plus" /></i>
                    <div class="tools-right">
                        <div class="t-desc ">Rotate</div>
                        <div class="icon" @click="handleRotate(-90)"><svg-icon name="rotate" /></div>
                        <div class="icon" @click="handleRotate(90)"><svg-icon name="rotate-right" /></div>
                    </div>
                    
                </div>

                <p class="text">
                    The default logo is currently set to the one from your portal settings. This doesn’t have to match the portal logo. <span class="link" @click="resetImage">Click here</span> to reset to the default logo.<br/><br/>
                    Please upload a PNG image (max size: 200KB). Recommend to use PNG image with transparent background.
                </p>
            
                <footer class="upload-footer">
                    <div class="footer-left">
                        <Button :border_r="6" size="40" color="white" @click.native="$refs.file.click()">Change image</Button>
                    </div>
                    <div class="footer-right">
                        <!-- <Button :border_r="6" size="40" :style="'border'" color="white" @click.native="appltToAll()" :is_disabled="!img_data.src">Apply to all</Button> -->
                        <Button :border_r="6" size="40" color="dark-blue" @click.native="save()" :is_disabled="!img_data.src">Save & Apply</Button>
                    </div>
                </footer>
            </div>
        </div>

        <div class="bg" @click="$emit('closeModal')"></div>
    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import Pool from '@/utils/Pool';
import Loading from '@/components/ui/Loading.vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import VueSlider from 'vue-3-slider-component';
import getMimeType from '@/utils/getMimeType';

export default {
    name: 'upload-avatar',
    emits: ['closeModal'],
    data() {
        return {
            scale_current: 0,//use
            scale_key:0,
            img_data: {
                src: null,
                img_blob:null,
                img:null,
            },
            img_rotate:0,
            is_loading: false,

        }
    },

    props: {
        title:{
            type: String,
            default: 'Logo - Application',
        },

        img_url:{
            type: String,
            default: '',
        }
    },

    components: {
        VueSlider,
        Loading,
        Cropper,
        Button,
    },

    watch:{
        scale_current(newVal, oldVal) {
            if(newVal > oldVal ){
                this.handleZoomFun(1);
            }else{
                this.handleZoomFun(0);
            }
        }
    },

    methods: {
        handleScaleValue(val){
            
            if(val &&  this.scale_current > 0 ){
                this.scale_current--;
            }else if(!val && this.scale_current < 5 ){
                this.scale_current +=1;
            }
        },

        handleZoomFun(val){
            let value=false;
            //+要用1 -要用0
            if (this.scale_current > 0 && this.scale_current < 5) {
                if(val){
                    value= ( val + this.scale_current * 0.1).toFixed(1);
                }else{
                    value= this.updateScaleFactor(this.scale_current).toFixed(1);
                }
                
            } else if(this.scale_current === 5){
                value= 2;
            }
            else if(this.scale_current === 0){
                value= 0;
            }

            if(value!==false){
                this.$refs.cropper.zoom(value);
            }
        },

        updateScaleFactor(scale) {
            const scaleMap = {
                4: 0.9,
                3: 0.8,
                2: 0.7,
                1: 0.6,
            };
            return scaleMap[scale] || 0; 
        },

        handleRotate(val){
            this.$refs.cropper.rotate(val);
        },

        loadImage(event) {
            let vi = this

            // Reference to the DOM input element
            const { files } = event.target;
            // Ensure that you have a file before attempting to read it
            if (files && files[0]) {
                console.log('files[0]',files[0])
                // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
                if (this.img_data.src) {
                    URL.revokeObjectURL(this.img_data.src)
                }
                // 2. Create the blob link to the file to optimize performance:
                const blob = URL.createObjectURL(files[0]);

                // Create a new FileReader to read this image binary data
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.img_data = {
                        src: blob,
                        type: getMimeType(e.target.result, files[0].type),
                    };
                };
                reader.readAsArrayBuffer(files[0]);

            }
        },

        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            };
        },

        onChange(result) {
            const cropper = this.$refs.cropper;
            if (cropper) {
                const { coordinates, imageSize } = cropper;

                if (
                    imageSize.width / imageSize.height >
                    coordinates.width / coordinates.height
                ) {
                    // Determine the position of slider bullet
                    // It's 0 if the stencil has the maximum size and it's 1 if the has the minimum size
                    this.zoom =
                        (cropper.imageSize.height - cropper.coordinates.height) /
                        (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
                } else {
                    this.zoom =
                        (cropper.imageSize.width - cropper.coordinates.width) /
                        (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
                }
            }
        },

        //btn
        resetImage(){

        },

        appltToAll(){

        },

        save(){
            const { canvas } = this.$refs.cropper.getResult();

            canvas.toBlob((blob) => {
                this.img_data.img_blob = blob;
                this.img_data.img = URL.createObjectURL(blob)
                this.callUpdateApi();
                
            }, this.img_data.type);
        },

        callUpdateApi() {
            this.is_loading = true;
            //have logo,favicon,name
            let form_data = new FormData();
            form_data.append('ambassador_logo', this.img_data.img_blob);

            //CALL API
            this.$ajax(`/ambassador/update-ambassador-logo`, {
                method: 'post',
                data: form_data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                const resData = res.data.data;
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Save & Apply successfully.`);
                this.$emit('closeModal',resData);
                this.is_loading = false;
            }).catch(err => {
                console.log(err)
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        start(){
            console.log('this.img_url',this.img_url)
            //this.img_data.src=this.img_url;
            this.$refs.file.click();
            //console.log('this.img_data.src',this.img_data.src)
        },

    },

    mounted() {
        this.start();
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}


.upload-image-for-pro {
    position: fixed;
    z-index: 9990;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    transition: opacity 0.3s ease;

    .link{
        color:var(--blue);
        cursor: pointer;
    }

    i{
        cursor: pointer;
    }

    .disabeld{
        cursor: not-allowed;

        svg{
            fill:var(--black-45);
        }
    }

    .img-wrap {
        @include flexCenter();
        justify-content: center;
        width: 50%;
        margin: 35px auto;
        height: 300px;
        border: 2px dashed var(--black-40);
        border-radius: 5px;
        position: relative;
        cursor: pointer;

        .image-container img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }

        .img-wrap-placeholder {
            flex-direction: column;
            @include flexCenter();
            justify-content: center;
            text-align: center;
        }
        
        .image-placeholder{
            .ui-button{
                margin-top: 12px;
                color:var(--white);
                svg{
                    fill:var(--white);
                    width: 12px;
                    height: 12px;
                    margin-right: 8px;
                }
            }
        }

        .image-placeholder span {
            font-size: 16px;
            color: #555;
        }

        .avatar-input {
            display: none;
        }
    }


    .ui-modal--container {
        width: 670px;
        max-height: 95vh;
        margin: auto;
        background-color: #fff;
        border-radius: 16px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
        transition: all 0.3s ease;
        position: relative;
        z-index: 3;

        .title-box{
            @include flexCenter();
            justify-content: space-between;
            padding: 8px 16px;

            .title{
                font:var(--font-med-20);
            }

            .svg-icon{
                width: 16px;
                height: 16px;
                cursor: pointer;
            }
        }

        .vue-advanced-cropper{
            position: absolute;
            left: 0;
            top: 0;

            &.vue-advanced-cropper-class{
                height: 370px;
                width: 670px;
                background-color: var(--black-40);
            }
        }
    }

    .bg {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
    }
}

.upload-image-for-pro{
    .upload {
        width: 100%;
        height: 370px;
        position: relative;
        background-color: var(--bg-10);
        //aspect-ratio: 1/1;
        overflow: hidden;

        .loading {
            position: absolute;
        }
    }

    .text {
        font-size:16px;
        padding: 24px;
        color:var(--black-75);
    }

    .upload-footer {
        @include flexCenter();
        justify-content: space-between;
        padding:24px 16px;
        .ui-button{
            text-transform:uppercase;
        }

        .footer-right{
            .ui-button {
                &:nth-child(2) {
                    margin-left: 16px;
                }
            }
        }
    }


    .tools {
        display: flex;
        align-items: center;
        border: solid 1px var(--black-40);

        .t-desc{
            margin-left: 16px;
        }

        .tools-right{
            display: flex;
            align-items: center;
            border-left: solid 1px var(--black-40);
            height: 100%;
            padding: 8px;
            margin-right:16px;

            .t-desc{
                margin-left: 4px;
                margin-right: 12px;
            }
        }

        &.disabled {
            opacity: 0.5;
            pointer-events: none;
        }

        .icon {
            height: 24px;
            width: 24px;
            min-width: 24px;
            border-radius: 50%;
            border: 1px solid var(--dark-blue);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:first-child {
                margin-right: 10px;
            }

            &:last-child {
                margin-left: 10px;
            }

            svg {
                height: 14px;
                width: 14px;
                fill: var(--dark-blue);
            }
        }

        i {
            svg {
                height: 16px;
                width: 16px;
                fill: var(--dark-blue);
                margin:8px;
            }
        }


        .vue-slider {
            flex: 1;
            position: relative;
            margin: 0;
            padding: 8px 0;

            .vue-slider-dot-tooltip-inner{
                display: none;
            }

            .vue-slider-dot-handle-focus,.vue-slider-process{
                background-color: var(--dark-blue);
                box-shadow:none;
            }

            .vue-slider-dot{
                width: 18px;
                height: 18px;
            }

        }
    }
}
</style>
